function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "error-icon",
  transform: "translate(-321.671 -44.336)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_511",
  "data-name": "Grupo 511",
  transform: "translate(328.671 51.336)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_509",
  "data-name": "Grupo 509",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1405",
  "data-name": "Ret\\xE2ngulo 1405",
  width: 1.235,
  height: 12.907,
  transform: "translate(0 0.873) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_510",
  "data-name": "Grupo 510",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1406",
  "data-name": "Ret\\xE2ngulo 1406",
  width: 12.907,
  height: 1.235,
  transform: "translate(0 9.127) rotate(-45)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_512",
  "data-name": "Grupo 512",
  transform: "translate(321.671 44.336)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_846",
  "data-name": "Caminho 846",
  d: "M333.6,68.754a12,12,0,1,1,12-12A12.013,12.013,0,0,1,333.6,68.754Zm0-22.533a10.534,10.534,0,1,0,10.535,10.533A10.545,10.545,0,0,0,333.6,46.221Z",
  transform: "translate(-321.604 -44.754)"
})));

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ccc9b53b.svg";
export { ForwardRef as ReactComponent };